import { apiClient } from "./api";

// Authentication API endpoints matching Spring Boot backend
export const authService = {
  // Login user - matches POST /api/auth/login
  login: (credentials) => {
    return apiClient.post("/auth/login", {
      username: credentials.username,
      password: credentials.password,
    });
  },

  // Refresh access token - matches POST /api/auth/token/refresh
  refreshToken: (refreshToken) => {
    return apiClient.post("/auth/token/refresh", { refreshToken });
  },

  // Get current user info - matches GET /api/auth/whoAmI
  whoAmI: () => {
    return apiClient.get("/auth/whoAmI");
  },

  // Register new user (if needed in future)
  register: (userData) => {
    return apiClient.post("/auth/register", userData);
  },

  // Logout user - calls backend to clear httpOnly cookie
  logout: () => {
    // Call backend to clear httpOnly cookie
    return apiClient.post("/auth/logout");
  },

  // Forgot password (if needed in future)
  forgotPassword: (email) => {
    return apiClient.post("/auth/forgot-password", { email });
  },

  // Reset password (if needed in future)
  resetPassword: (token, newPassword) => {
    return apiClient.post("/auth/reset-password", {
      token,
      password: newPassword,
    });
  },

  // Change password (if needed in future)
  changePassword: (currentPassword, newPassword) => {
    return apiClient.post("/auth/change-password", {
      currentPassword,
      newPassword,
    });
  },

  // Verify email (if needed in future)
  verifyEmail: (token) => {
    return apiClient.post("/auth/verify-email", { token });
  },

  // Resend verification email (if needed in future)
  resendVerification: (email) => {
    return apiClient.post("/auth/resend-verification", { email });
  },

  // Legacy method - use whoAmI instead
  getCurrentUser: () => {
    return authService.whoAmI();
  },

  // Legacy method - use whoAmI instead
  checkAuth: () => {
    return authService.whoAmI();
  },
};
